import React from 'react';
import { Home, Container } from '../../components';

const HomePage = () =>
<>
 <Container>
 <Home />
 </Container>
</>   

export default HomePage;